import type { AtomModel, Font, FormControlSetting } from '@/app/editor/iframe/atom/Atom.model';
import { GpChildProduct } from '@/app/editor/iframe/atom/module/GpChildProduct';
import HELPER from '@/app/utils/HELPER';

const FormControlSettings: Array<FormControlSetting> = [
  {
    type: 'isNewLine',
    name: 'isNewLine',
    targetSelector: '.gf_btn-upload',
    property: '',
    default_value: '0',
  },
  {
    type: 'css:typography',
    name: 'secondarySize',
    targetSelector: '.gf_btn-secondarytext',
    property: 'font-size',
    unit: 'px',
    default_value: '20px',
    selfSelector: '-1,1',
  },
  {
    type: 'css:typography',
    name: 'secondaryFont',
    targetSelector: '.gf_btn-secondarytext',
    property: 'font-family',
    default_value: '',
    selfSelector: '-1,1',
  },
  {
    type: 'font-style',
    name: 'secondaryFontStyle',
    targetSelector: '.gf_btn-secondarytext',
    property: 'font-weight',
    default_value: '',
    dataValue: 'bold,italic,underline',
    selfSelector: '-1,1',
  },
  {
    type: 'css:typography',
    name: 'secondaryTextTransform',
    targetSelector: '.gf_btn-secondarytext',
    property: 'text-transform',
    selfSelector: '-1,1',
  },
  {
    type: 'css',
    name: 'secondaryColor',
    targetSelector: '.gf_btn-secondarytext',
    property: 'color',
    default_value: '',
    selfSelector: '-1,1',
  },
  // Typography
  {
    type: 'css:typography',
    name: 'font-size',
    targetSelector: '.gf_btn-upload',
    property: 'font-size',
    unit: 'px',
    default_value: '20px',
    selfSelector: '-1,1',
  },
  {
    type: 'css:typography',
    name: 'font',
    targetSelector: '.gf_btn-upload',
    property: 'font-family',
    default_value: '',
    selfSelector: '-1,1',
  },
  {
    type: 'font-style',
    name: 'font-style',
    targetSelector: '.gf_btn-upload',
    property: 'font-weight',
    default_value: '',
    dataValue: 'bold,italic,underline',
    selfSelector: '-1,1',
  },
  {
    type: 'css:typography',
    name: 'textTransform',
    targetSelector: '.gf_btn-upload',
    property: 'text-transform',
    selfSelector: '-1,1',
  },
  {
    type: 'css',
    name: 'button-color',
    targetSelector: '.gf_btn-upload',
    property: 'background-color',
    default_value: '#eeeeee',
    selfSelector: '-1,1',
  },
  {
    type: 'css',
    name: 'color',
    targetSelector: '.gf_btn-upload',
    property: 'color',
    default_value: '#585858',
    selfSelector: '-1,1',
  },
  {
    type: 'css',
    name: 'width',
    targetSelector: '.gf_btn-upload',
    property: 'width',
    default_value: '100%',
    require: true,
    unit: '%',
    selfSelector: '-1,1',
  },
  {
    type: 'css',
    name: 'height',
    targetSelector: '.gf_btn-upload',
    property: 'height',
    default_value: '',
    selfSelector: '-1,1',
  },
  {
    type: 'previewWidth',
    name: 'previewWidth',
    targetSelector: '.gf_btn-upload',
    property: '',
    list_unit: 'px,%',
    default_value: '100%',
  },
  {
    type: 'previewHeight',
    name: 'previewHeight',
    targetSelector: '.gf_btn-upload',
    property: '',
    list_unit: 'px,%',
    default_value: '0',
  },
  {
    type: 'custom:align',
    name: 'alignment',
    targetSelector: '.gf_to-align',
    property: '',
    default_value: 'center',
  },
  {
    type: 'html:extraClass',
    name: 'extraClass',
    targetSelector: '.module',
    property: 'data-exc',
    default_value: '',
  },
];

/**
 * File Upload Atom
 */
export class GpPFileUpload extends GpChildProduct {
  public $el: JQuery;

  /**
   * Thông tin riêng của Atom
   * @returns object watch
   */
  getDataAtom(): AtomModel {
    const data: AtomModel = {
      type: this.getType(),
      id: this.getId(),
      nodeId: this.getIdNode(),
      name: '(P) File Upload',
      slug: 'p-file-upload',
      groupName: 'Module',
      settings: this.getSettings(),
      formControlSettings: FormControlSettings,
      data: this.getDataChilds(),
      html: this.getTemplate(),
      class: '.gf_btn-upload',
      style: this.getStyle(),
      script: this.getScript(),
      libs: this.getLibs(),
      fonts: [] as Array<Font>,
      version: 1,
    };
    return data;
  }

  /**
   * override getLabel từ Atom
   * @returns Name
   */
  getLabel(): string {
    return this.$el.attr('data-label') || '(P) File Upload';
  }
  /**
   * override getLabel từ Atom
   * @returns Slug
   */
  getSlug(): string {
    return this.$el.attr('data-slug') || 'p-file-upload';
  }
  /**
   * getFormControlSettings;
   * @returns setting read/write from left-sidebar to live page
   */
  getFormControlSettings(): Array<FormControlSetting> {
    return FormControlSettings;
  }
  /**
   * get Data from html attr
   * @returns Group Name
   */
  getGroupName(): string {
    return this.$el.attr('data-groupname') || 'Module';
  }

  /**
   * GetModuleId
   * @returns number
   */
  getModuleId() {
    let moduleId = HELPER.MakeIdInsideList(this.$el);
    if (moduleId == '') {
      moduleId = this.$el.attr('data-id') || HELPER.MakeId().toString();
    }
    return moduleId;
  }

  /**
   * cloneAtom
   * @param $atomClone :jQuery
   * @param templateTmp :string
   * @returns $atomClone
   */
  cloneAtom($atomClone: JQuery, templateTmp: string): JQuery {
    const moduleId = this.getModuleId();
    templateTmp = templateTmp.replace(/{{module-id}}/g, moduleId);
    return $atomClone.html(templateTmp);
  }
}
